import { createFileRoute } from "@tanstack/react-router";

import { generationsStepRouteOptions } from "@/features/Generations/stepRoute";

export const Route = createFileRoute(
  "/_auth/generations/$siteId/new/collection/$stepId",
)(generationsStepRouteOptions("collection"));
